import { render, staticRenderFns } from "./FormAddPlan.vue?vue&type=template&id=19c7664e&scoped=true"
import script from "./FormAddPlan.vue?vue&type=script&lang=js"
export * from "./FormAddPlan.vue?vue&type=script&lang=js"
import style0 from "./FormAddPlan.vue?vue&type=style&index=0&id=19c7664e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c7664e",
  null
  
)

export default component.exports